function triggerZasuwaProductScan(root) {
  if (window.ZasuwaInsights && typeof window.ZasuwaInsights.scanProducts === 'function') {
    window.ZasuwaInsights.scanProducts(root);
  }
}

if (!customElements.get('complete-the-look')) {
  customElements.define(
    'complete-the-look',
    class CompleteTheLook extends HTMLElement {
      connectedCallback() {
        this.submitButton = this.querySelector('[data-complete-the-look-submit]');
        this.submitText = this.querySelector('[data-complete-the-look-submit-text]');
        this.feedback = this.querySelector('[data-complete-the-look-feedback]');
        this.candidatesPanel = this.querySelector('[data-complete-the-look-candidates]');
        this.candidatesTitle = this.querySelector('[data-complete-the-look-candidates-title]');
        this.candidatesStatus = this.querySelector('[data-complete-the-look-candidates-status]');
        this.candidatesList = this.querySelector('[data-complete-the-look-candidates-list]');
        this.candidatesClose = this.querySelector('[data-complete-the-look-candidates-close]');
        this.candidatesShowMore = this.querySelector('[data-complete-the-look-candidates-show-more]');
        this.items = Array.from(this.querySelectorAll('[data-complete-the-look-item]'));
        this.offerPanel = this.querySelector('[data-complete-the-look-offer]');
        this.offerBadge = this.querySelector('[data-complete-the-look-offer-badge]');
        this.offerNote = this.querySelector('[data-complete-the-look-offer-note]');
        this.offerEnabled = this.dataset.completeTheLookOfferEnabled === 'true';
        this.offerValue = Number(this.dataset.completeTheLookOfferValue || 0);
        this.offerMinimumQuantity = Number(this.dataset.completeTheLookOfferMinimumQuantity || 0);
        this.candidateCache = new Map();
        this.activeCandidateKey = null;
        this.activeCandidateRequestId = 0;
        this.activeCandidatePage = 1;
        this.activeCandidateItem = null;

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onCheckboxToggle = this.onCheckboxToggle.bind(this);
        this.onTitleClick = this.onTitleClick.bind(this);
        this.onActionClick = this.onActionClick.bind(this);
        this.onCloseCandidatesClick = this.onCloseCandidatesClick.bind(this);
        this.onShowMoreClick = this.onShowMoreClick.bind(this);
        this.onCheckMoreClick = this.onCheckMoreClick.bind(this);
        this.onReplaceClick = this.onReplaceClick.bind(this);

        this.addEventListener('change', this.onChange);
        this.addEventListener('change', this.onCheckboxToggle);
        this.addEventListener('click', this.onTitleClick);
        this.addEventListener('click', this.onActionClick);
        this.addEventListener('click', this.onReplaceClick);
        this.submitButton?.addEventListener('click', this.onSubmit);
        this.candidatesClose?.addEventListener('click', this.onCloseCandidatesClick);
        this.candidatesShowMore?.addEventListener('click', this.onShowMoreClick);
        this.syncSelectionStates();
        requestAnimationFrame(() => this.syncSelectionStates());
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('change', this.onCheckboxToggle);
        this.removeEventListener('click', this.onTitleClick);
        this.removeEventListener('click', this.onActionClick);
        this.removeEventListener('click', this.onReplaceClick);
        this.submitButton?.removeEventListener('click', this.onSubmit);
        this.candidatesClose?.removeEventListener('click', this.onCloseCandidatesClick);
        this.candidatesShowMore?.removeEventListener('click', this.onShowMoreClick);
      }

      onChange(event) {
        const select = event.target.closest('[data-complete-the-look-variant-select]');
        if (!select) return;

        const item = select.closest('[data-complete-the-look-item]');
        if (!item) return;

        this.syncSelectionStates();
      }

      onCheckboxToggle(event) {
        const checkbox = event.target.closest('[data-complete-the-look-checkbox]');
        if (!checkbox) return;

        this.syncSelectionStates();
      }

      onTitleClick(event) {
        const titleLink = event.target.closest('.complete-the-look__product-title');
        if (!titleLink) return;

        const item = titleLink.closest('[data-complete-the-look-item]');
        const checkbox = item?.querySelector('[data-complete-the-look-checkbox]');
        if (!checkbox || checkbox.disabled) return;

        event.preventDefault();
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      }

      onActionClick(event) {
        const checkMoreButton = event.target.closest('[data-complete-the-look-check-more]');
        if (checkMoreButton) {
          event.preventDefault();
          event.stopPropagation();
          this.onCheckMoreClick(event);
          return;
        }
      }

      onReplaceClick(event) {
        const replaceButton = event.target.closest('[data-complete-the-look-replace]');
        if (!replaceButton) return;

        event.preventDefault();
        event.stopPropagation();

        const candidateCard = replaceButton.closest('[data-complete-the-look-candidate]');
        if (!candidateCard) return;

        const dataScript = candidateCard.querySelector('[data-complete-the-look-candidate-data]');
        if (!dataScript) return;

        let candidateData = null;
        try {
          candidateData = JSON.parse(dataScript.textContent || '{}');
        } catch (error) {
          return;
        }

        const currentItem =
          this.activeCandidateItem ||
          this.items.find((item) => item.dataset.completeTheLookProductHandle === this.activeCandidateProductHandle);
        if (!currentItem || !candidateData) return;

        const replaced = this.replaceItemWithCandidate(currentItem, candidateData, candidateCard);
        if (replaced) {
          this.closeCandidatesPanel();
        }
      }

      onCheckMoreClick(event) {
        const button = event.target.closest('[data-complete-the-look-check-more]');
        const mediaItem = button?.closest('[data-complete-the-look-media-item]');
        if (!mediaItem) return;

        const itemHandle = mediaItem.dataset.completeTheLookProductHandle || '';
        const item = this.items.find((entry) => entry.dataset.completeTheLookProductHandle === itemHandle);
        if (!item) return;

        this.toggleCandidatesPanel(item);
      }

      onCloseCandidatesClick(event) {
        event.preventDefault();
        this.closeCandidatesPanel();
      }

      onShowMoreClick(event) {
        event.preventDefault();
        const currentItem = this.items.find((item) => item.dataset.completeTheLookProductHandle === this.activeCandidateProductHandle);
        if (!currentItem) return;

        const nextPage = Number(this.candidatesShowMore?.dataset.nextPage || this.activeCandidatePage + 1);
        this.openCandidatesPanel(currentItem, nextPage);
      }

      toggleCandidatesPanel(item) {
        if (!this.candidatesPanel || !item) return;

        const itemKey = this.getCandidateKey(item);
        if (!itemKey) return;

        if (this.activeCandidateKey === itemKey && !this.candidatesPanel.hidden) {
          this.closeCandidatesPanel();
          return;
        }

        this.activeCandidateKey = itemKey;
        this.openCandidatesPanel(item, 1);
      }

      async openCandidatesPanel(item, page = 1) {
        if (!this.candidatesPanel || !this.candidatesList || !this.candidatesStatus) return;

        const collectionHandle = item.dataset.completeTheLookCollection || '';
        const currentProductHandle = this.dataset.completeTheLookCurrentProductHandle || '';
        const excludedProductHandle = item.dataset.completeTheLookProductHandle || '';

        this.activeCandidatePage = page;
        this.activeCandidateProductHandle = excludedProductHandle;
        this.activeCandidateItem = item;
        this.candidatesPanel.hidden = false;
        this.candidatesTitle.textContent = '';
        this.candidatesList.innerHTML = '';
        this.setCandidatesStatus('Loading...', false);
        const requestId = ++this.activeCandidateRequestId;

        const requestUrl = this.buildCandidatesUrl({
          collectionHandle,
          currentProductHandle,
          page,
        });

        const cacheKey = `${collectionHandle}::${page}`;
        this.activeCandidateKey = this.getCandidateKey(item);

        if (this.candidateCache.has(cacheKey)) {
          this.renderCandidatesPanel(this.candidateCache.get(cacheKey), excludedProductHandle);
          return;
        }

        try {
          const response = await fetch(requestUrl, {
            headers: {
              Accept: 'text/html',
              'X-Requested-With': 'XMLHttpRequest',
            },
          });

          if (!response.ok) {
            throw new Error(`Candidate request failed: ${response.status}`);
          }

          const html = await response.text();
          if (requestId !== this.activeCandidateRequestId) return;
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const panel = parsed.querySelector('[data-complete-the-look-candidates]');

          if (!panel) {
            throw new Error('Candidate panel missing');
          }

          const panelHTML = panel.outerHTML;
          this.candidateCache.set(cacheKey, panelHTML);
          if (requestId !== this.activeCandidateRequestId) return;
          this.renderCandidatesPanel(panelHTML, excludedProductHandle);
        } catch (error) {
          if (requestId !== this.activeCandidateRequestId) return;
          this.showCandidatesError();
        }
      }

      renderCandidatesPanel(panelHTML, excludedProductHandle = '') {
        if (!this.candidatesPanel || !this.candidatesList || !this.candidatesStatus) return;

        const parsed = new DOMParser().parseFromString(panelHTML, 'text/html');
        const panel = parsed.querySelector('[data-complete-the-look-candidates]');
        if (!panel) {
          this.showCandidatesError();
          return;
        }

        const title = panel.dataset.completeTheLookCandidatesTitle || '';
        this.candidatesTitle.textContent = title;
        const list = panel.querySelector('[data-complete-the-look-candidates-list]');
        if (!list) {
          this.showCandidatesError();
          return;
        }

        if (excludedProductHandle) {
          list.querySelectorAll(`[data-candidate-product-handle="${this.escapeAttribute(excludedProductHandle)}"]`).forEach((candidate) => {
            candidate.remove();
          });
        }

        const emptyMessage = panel.querySelector('[data-complete-the-look-candidates-empty]');
        const hasCandidates = list.children.length > 0;
        const hasMore = panel.dataset.completeTheLookCandidatesHasMore === 'true';
        const nextPage = panel.dataset.completeTheLookCandidatesNextPage || '';

        if (!hasCandidates && hasMore && nextPage) {
          const currentItem = this.items.find(
            (item) => item.dataset.completeTheLookProductHandle === this.activeCandidateProductHandle
          );
          if (currentItem) {
            this.openCandidatesPanel(currentItem, Number(nextPage));
            return;
          }
        }

        this.candidatesList.innerHTML = list.innerHTML;
        triggerZasuwaProductScan(this.candidatesList);
        if (this.candidatesShowMore) {
          this.candidatesShowMore.dataset.nextPage = nextPage;
          this.candidatesShowMore.hidden = !hasMore;
        }

        if (!hasCandidates) {
          if (!hasMore) {
            this.setCandidatesStatus(emptyMessage?.textContent?.trim() || 'No other options available.', false);
          } else {
            this.setCandidatesStatus('', true);
          }
          return;
        }

        this.setCandidatesStatus('', true);
      }

      buildCandidatesUrl({ collectionHandle, currentProductHandle, page = 1 }) {
        const root = window.Shopify?.routes?.root || '/';
        const encodedCollection = encodeURIComponent(collectionHandle);
        const params = new URLSearchParams({
          section_id: 'complete-the-look-candidates',
          collection_handle: collectionHandle,
          current_product_handle: currentProductHandle,
          limit: '5',
        });
        if (page > 1) {
          params.set('page', String(page));
        }

        return `${root}collections/${encodedCollection}?${params.toString()}`;
      }

      getCandidateKey(item) {
        const collectionHandle = item.dataset.completeTheLookCollection || '';
        const productHandle = item.dataset.completeTheLookProductHandle || '';
        if (!collectionHandle || !productHandle) return '';

        return `${collectionHandle}::${productHandle}`;
      }

      setCandidatesStatus(message, hideWhenEmpty = false) {
        if (!this.candidatesStatus) return;

        if (message) {
          this.candidatesStatus.textContent = message;
          this.candidatesStatus.hidden = false;
          return;
        }

        if (hideWhenEmpty) {
          this.candidatesStatus.textContent = '';
          this.candidatesStatus.hidden = true;
        }
      }

      showCandidatesError() {
        if (!this.candidatesPanel || !this.candidatesList || !this.candidatesStatus) return;

        this.candidatesPanel.hidden = false;
        this.candidatesList.innerHTML = '';
        this.setCandidatesStatus('Unable to load options.', false);
      }

      closeCandidatesPanel() {
        if (!this.candidatesPanel || !this.candidatesList || !this.candidatesStatus) return;

        this.activeCandidateRequestId += 1;
        this.candidatesPanel.hidden = true;
        this.candidatesList.innerHTML = '';
        this.setCandidatesStatus('', true);
        this.activeCandidateKey = null;
        this.activeCandidatePage = 1;
        this.activeCandidateProductHandle = '';
        this.activeCandidateItem = null;
        if (this.candidatesShowMore) {
          this.candidatesShowMore.hidden = true;
          this.candidatesShowMore.dataset.nextPage = '';
        }
      }

      replaceItemWithCandidate(currentItem, candidateData, candidateCard) {
        const previousHandle = currentItem.dataset.completeTheLookProductHandle || '';
        const productLink = currentItem.querySelector('.complete-the-look__product-title');
        const priceEl = currentItem.querySelector('[data-complete-the-look-price]');
        const variantSelect = currentItem.querySelector('[data-complete-the-look-variant-select]');
        const variantIdInput = currentItem.querySelector('[data-complete-the-look-variant-id]');
        const mediaItem = this.querySelector(
          `[data-complete-the-look-media-item][data-complete-the-look-product-handle="${this.escapeAttribute(previousHandle)}"]`
        );
        const mediaTrigger = mediaItem?.querySelector('.complete-the-look__media-trigger');
        const mediaImage = mediaItem?.querySelector('.complete-the-look__media-image');
        const currentModal = currentItem.querySelector('quick-add-modal');
        const candidateModal = candidateCard.querySelector('quick-add-modal');

        currentItem.dataset.completeTheLookProductHandle = candidateData.handle || '';
        currentItem.dataset.completeTheLookProductId = String(candidateData.id || '');
        currentItem.dataset.completeTheLookProductUrl = candidateData.url || '';

        if (productLink) {
          productLink.setAttribute('href', candidateData.url || '#');
          productLink.textContent = candidateData.title || productLink.textContent;
        }

        if (priceEl && candidateData.selectedVariant?.price) {
          const originalMoney = candidateData.selectedVariant.price || '';
          const discountMoney = candidateData.selectedVariant.discountPrice || originalMoney;
          const originalEl = priceEl.querySelector('[data-complete-the-look-price-original]');
          const discountEl = priceEl.querySelector('[data-complete-the-look-price-discount]');
          priceEl.dataset.originalPriceMoney = originalMoney;
          priceEl.dataset.discountPriceMoney = discountMoney;
          if (originalEl) {
            originalEl.textContent = originalMoney;
          }
          if (discountEl) {
            discountEl.textContent = discountMoney;
          }
        }

        if (variantSelect && Array.isArray(candidateData.variants) && candidateData.variants.length > 1) {
          variantSelect.innerHTML = candidateData.variants
            .map((variant) => {
              const selected = String(variant.id) === String(candidateData.selectedVariant?.id) ? ' selected' : '';
              const disabled = variant.available ? '' : ' disabled';
              return `<option value="${variant.id}" data-variant-price-money="${this.escapeHtml(variant.price)}" data-variant-discount-price-money="${this.escapeHtml(variant.discountPrice || variant.price)}"${selected}${disabled}>${this.escapeHtml(variant.title)}</option>`;
            })
            .join('');
          variantSelect.value = String(candidateData.selectedVariant?.id || candidateData.variants[0]?.id || '');
        } else if (variantSelect) {
          const firstVariant = candidateData.selectedVariant || candidateData.variants?.[0];
          if (firstVariant) {
            variantSelect.innerHTML = `<option value="${firstVariant.id}" selected data-variant-price-money="${this.escapeHtml(firstVariant.price)}" data-variant-discount-price-money="${this.escapeHtml(firstVariant.discountPrice || firstVariant.price)}">${this.escapeHtml(firstVariant.title)}</option>`;
            variantSelect.value = String(firstVariant.id);
          }
        }

        if (variantIdInput) {
          variantIdInput.value = String(candidateData.selectedVariant?.id || candidateData.variants?.[0]?.id || '');
        }

        if (mediaTrigger) {
          mediaTrigger.setAttribute('data-product-url', candidateData.url || '');
          mediaTrigger.setAttribute('aria-label', `Quick view ${candidateData.title || ''}`.trim());
          const mediaTriggerImage = mediaTrigger.querySelector('img');
          if (mediaTriggerImage && candidateData.image) {
            mediaTriggerImage.setAttribute('src', candidateData.image);
          }
          if (mediaTriggerImage && candidateData.imageSrcset) {
            mediaTriggerImage.setAttribute('srcset', candidateData.imageSrcset);
          }
          if (mediaTriggerImage) {
            mediaTriggerImage.setAttribute('alt', candidateData.imageAlt || candidateData.title || '');
          }
        }

        if (mediaItem) {
          mediaItem.dataset.completeTheLookProductHandle = candidateData.handle || '';
          mediaItem.dataset.completeTheLookProductUrl = candidateData.url || '';
        }

        if (mediaImage) {
          const img = mediaImage.tagName === 'IMG' ? mediaImage : mediaImage.querySelector('img');
          if (img && candidateData.image) {
            img.setAttribute('src', candidateData.image);
            if (candidateData.imageSrcset) {
              img.setAttribute('srcset', candidateData.imageSrcset);
            }
            img.setAttribute('alt', candidateData.imageAlt || candidateData.title || '');
          }
        }

        if (currentModal && candidateModal) {
          const currentTemplate = currentModal.querySelector('template[data-quick-buy-gallery-template]');
          const candidateTemplate = candidateModal.querySelector('template[data-quick-buy-gallery-template]');
          if (candidateTemplate) {
            if (currentTemplate) {
              currentTemplate.replaceWith(candidateTemplate.cloneNode(true));
            } else {
              currentModal.append(candidateTemplate.cloneNode(true));
            }
          } else if (currentTemplate) {
            currentTemplate.remove();
          }
        }

        const dialog = currentModal?.querySelector('[role="dialog"]');
        if (dialog) {
          dialog.setAttribute('aria-label', `Quick view ${candidateData.title || ''}`.trim());
        }

        this.activeCandidateProductHandle = candidateData.handle || '';
        this.syncSelectionStates();

        if (currentItem && candidateCard) {
          currentItem.classList.remove('complete-the-look__item--disabled');
        }

        this.syncSelectionStates();
        return true;
      }

      escapeHtml(value) {
        return String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
      }

      getSectionId() {
        const blockId = this.getAttribute('data-block-id') || '';
        return blockId;
      }

      escapeAttribute(value) {
        if (window.CSS && typeof window.CSS.escape === 'function') {
          return window.CSS.escape(value);
        }

        return value.replace(/["\\]/g, '\\$&');
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.isLoading) return;

        const items = this.getSelectedItems();
        if (!items.length) {
          this.showFeedback('Select at least one item.');
          return;
        }

        this.setLoading(true);
        this.showFeedback('');

        const cart = this.getCartElement();
        const sectionsToRender = cart?.getSectionsToRender?.().map((section) => section.id) || [];
        const cartAddUrl = `${window.Shopify?.routes?.root || '/'}cart/add.js`;
        const payload = {
          items,
          sections: sectionsToRender,
          sections_url: `${window.location.pathname}${window.location.search}`,
        };

        fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(payload),
        })
          .then(async (response) => {
            const data = await this.readCartResponse(response, 'Cart add');

            if (!response.ok || data.status) {
              throw data;
            }

            const firstItem = Array.isArray(data.items) ? data.items[0] : data.item || null;
            const updatePayload = {
              source: 'complete-the-look',
              productVariantId: firstItem?.id,
              cartData: data,
            };

            const cartUpdate = typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'
              ? publish(PUB_SUB_EVENTS.cartUpdate, updatePayload)
              : Promise.resolve();

            if (!cart || typeof cart.renderContents !== 'function') {
              window.location = window.routes?.cart_url || '/cart';
              return;
            }

            return cartUpdate.then(() => {
              cart.renderContents({
                ...data,
                id: firstItem?.id,
                key: firstItem?.key,
              });
            });
          })
          .catch((error) => {
            if (error?.status === 429) {
              console.warn('[Complete the Look cart add]', {
                status: error.status,
                url: error.url,
                message: error?.message,
              });
              this.showFeedback('Please wait a moment and try again.');
              return;
            }

            const message = error?.description || error?.message || 'Unable to add selected items.';
            this.showFeedback(message);
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      async readCartResponse(response, contextLabel) {
        const contentType = response.headers.get('content-type') || '';
        const text = await response.text();
        const isJsonLike =
          contentType.includes('application/json') ||
          contentType.includes('application/javascript') ||
          contentType.includes('text/javascript');

        if (isJsonLike) {
          try {
            return JSON.parse(text);
          } catch (error) {
            const jsonError = new Error(
              `${contextLabel} returned invalid JSON (status ${response.status}, url ${response.url || 'unknown'}).`,
            );
            jsonError.status = response.status;
            jsonError.url = response.url || 'unknown';
            jsonError.responseText = text.slice(0, 300);
            throw jsonError;
          }
        }

        console.error(
          `${contextLabel} returned HTML instead of JSON`,
          response.status,
          response.url || 'unknown',
          text.slice(0, 300),
        );
        const redirected = response.redirected ? ' redirected' : '';
        const htmlError = new Error(
          `${contextLabel} returned HTML instead of JSON${redirected} (status ${response.status}, url ${response.url || 'unknown'}).`,
        );
        htmlError.status = response.status;
        htmlError.url = response.url || 'unknown';
        htmlError.responseText = text.slice(0, 300);
        throw htmlError;
      }

      getCartElement() {
        return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      getSelectedItems() {
        const selectedItems = [];

        this.items.forEach((item) => {
          const checkbox = item.querySelector('[data-complete-the-look-checkbox]');
          if (!checkbox?.checked || checkbox.disabled) return;

          const variantIdInput = item.querySelector('[data-complete-the-look-variant-id]');
          const variantSelect = item.querySelector('[data-complete-the-look-variant-select]');
          const variantId = variantSelect?.value || variantIdInput?.value;
          if (!variantId) return;

          const selectedItem = {
            id: Number(variantId),
            quantity: 1,
          };

          selectedItem.properties = {
            _offer_source: 'pdp_multi_product_offer',
          };

          if (this.isOfferEligible()) {
            selectedItem.properties._offer_discount_percent = String(this.offerValue);
          }

          selectedItems.push(selectedItem);
        });

        return selectedItems;
      }

      getSelectedQuantity() {
        return this.items.reduce((count, item) => {
          const checkbox = item.querySelector('[data-complete-the-look-checkbox]');
          return count + (checkbox?.checked && !checkbox.disabled ? 1 : 0);
        }, 0);
      }

      isOfferEligible() {
        return this.offerEnabled && Number.isFinite(this.offerValue) && Number.isFinite(this.offerMinimumQuantity) && this.offerValue > 0 && this.offerMinimumQuantity > 0;
      }

      getSelectedVariantData(item) {
        const variantSelect = item.querySelector('[data-complete-the-look-variant-select]');
        const variantIdInput = item.querySelector('[data-complete-the-look-variant-id]');
        const selectedOption = variantSelect?.selectedOptions?.[0];
        const priceEl = item.querySelector('[data-complete-the-look-price]');

        return {
          variantId: variantSelect?.value || variantIdInput?.value || '',
          originalMoney:
            selectedOption?.dataset.variantPriceMoney ||
            priceEl?.dataset.originalPriceMoney ||
            priceEl?.querySelector('[data-complete-the-look-price-original]')?.textContent ||
            '',
          discountMoney:
            selectedOption?.dataset.variantDiscountPriceMoney ||
            priceEl?.dataset.discountPriceMoney ||
            priceEl?.querySelector('[data-complete-the-look-price-discount]')?.textContent ||
            '',
        };
      }

      updatePriceDisplay(item, offerApplied, isChecked) {
        const priceEl = item.querySelector('[data-complete-the-look-price]');
        if (!priceEl) return;

        const originalEl = priceEl.querySelector('[data-complete-the-look-price-original]');
        const discountEl = priceEl.querySelector('[data-complete-the-look-price-discount]');
        const { originalMoney, discountMoney } = this.getSelectedVariantData(item);
        const shouldDiscount = this.isOfferEligible() && offerApplied && isChecked;

        priceEl.dataset.originalPriceMoney = originalMoney;
        priceEl.dataset.discountPriceMoney = discountMoney || originalMoney;

        if (originalEl) {
          originalEl.textContent = originalMoney;
        }

        if (discountEl) {
          discountEl.textContent = discountMoney || originalMoney;
          discountEl.hidden = !shouldDiscount || !(discountMoney || originalMoney);
        }

        priceEl.classList.toggle('complete-the-look__price--discounted', shouldDiscount);
      }

      updateOfferState(offerApplied) {
        if (!this.offerPanel || !this.offerBadge || !this.offerNote || !this.isOfferEligible()) return;

        const badgeText = this.dataset.completeTheLookOfferBadgeText || 'Extra discount';
        const unlockText = this.dataset.completeTheLookOfferUnlockText || '';
        const appliedText = this.dataset.completeTheLookOfferAppliedText || `${badgeText} Applied`;

        this.offerBadge.textContent = badgeText;
        this.offerNote.textContent = offerApplied ? appliedText : unlockText;
        this.classList.toggle('complete-the-look--offer-applied', offerApplied);
      }

      syncSelectionStates() {
        const selectedQuantity = this.getSelectedQuantity();
        const offerApplied = this.isOfferEligible() && selectedQuantity >= this.offerMinimumQuantity;

        this.updateOfferState(offerApplied);

        this.items.forEach((item, index) => {
          const checkbox = item.querySelector('[data-complete-the-look-checkbox]');
          const mediaItem = this.querySelector(
            `[data-complete-the-look-media-item][data-complete-the-look-product-handle="${this.escapeAttribute(
              item.dataset.completeTheLookProductHandle || ''
            )}"]`
          );

          const isChecked = Boolean(checkbox?.checked) && !checkbox?.disabled;
          item.classList.toggle('complete-the-look__item--unchecked', !isChecked);
          mediaItem?.classList.toggle('complete-the-look__media-link--unchecked', !isChecked);
          this.updatePriceDisplay(item, offerApplied, isChecked);
        });
      }

      setLoading(isLoading) {
        this.isLoading = isLoading;
        if (this.submitButton) {
          this.submitButton.disabled = isLoading;
          this.submitButton.classList.toggle('is-loading', isLoading);
        }
        if (this.submitText) {
          this.submitText.textContent = isLoading ? 'ADDING...' : 'ADD SELECTED TO CART';
        }
      }

      showFeedback(message) {
        if (!this.feedback) return;

        if (message) {
          this.feedback.textContent = message;
          this.feedback.hidden = false;
          return;
        }

        this.feedback.textContent = '';
        this.feedback.hidden = true;
      }
    }
  );
}
